import { render, staticRenderFns } from "./DistributionCenter.vue?vue&type=template&id=70deb42f&"
import script from "./DistributionCenter.vue?vue&type=script&lang=js&"
export * from "./DistributionCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports